<template>
    <div id="email" @click="toggleEmail">



        <div class="email-box" @click.stop.revent="">
            <input type="text" placeholder="Votre prénom*" v-model="formular_mail.firstname"/>
            <input type="text" placeholder="Votre nom*" v-model="formular_mail.lastname"/>
            <input type="text" placeholder="Votre addresse e-mail*" v-model="formular_mail.from"/>
            <input type="text" placeholder="E-mail du destinataire*" v-model="formular_mail.to"/>
            <textarea type="text" placeholder="Votre message" v-model="formular_mail.message"></textarea>
            <vue-recaptcha class="recaptcha"
                           ref="recaptcha"
                           :sitekey="recaptcha_public_key"
                           @verify="onCaptchaVerified"
                           @expired="onCaptchaExpired"
            ></vue-recaptcha>
            <button type="submit" class="button" @click="submit">Envoyer</button>
        </div>

        <div class="email-close z-10 cursor-pointer"  @click.stop.prevent="toggleEmail">
            <span class="text-3xl text-white">&times;</span>
        </div>
    </div>
</template>

<script>
    import VueRecaptcha from 'vue-recaptcha';
    import Email from "../services/Email";

    export default {
        name: "Email",
        data: function () {
            return {
                formular_mail: {
                    xmloutput: '',
                    lang: '',
                    g_recaptcha_response: '',
                    firstname: '',
                    lastname: '',
                    from: '',
                    to: '',
                    message: '',
                }
            }
        },
        components: {VueRecaptcha},

        computed: {
            recaptcha_public_key: function () {
                return window.location.href.indexOf('localhost') !== -1
                        ? '6LeC6lQUAAAAAHDLOo562BXUbRpBRCwx7PlHru4N'
                        : window.$application.config.recaptcha_key;
            }
        },

        mounted: function () {
        },
        methods: {
            toggleEmail: function () {
                const self = this;
                self.clearEmail();
                $eventbus.$emit('toggle:email');
            },
            //
            isValidEmail: function (email) {
                var re = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                return re.test(email) ? true : false;
            },
            //
            submit: function () {
                const self = this;
                // preluare si formatare date
                self.formular_mail.lang = 'fr';
                self.formular_mail.firstname = self.formular_mail.firstname.trim();
                self.formular_mail.lastname = self.formular_mail.lastname.trim();
                self.formular_mail.from = self.formular_mail.from.trim().toLowerCase();
                self.formular_mail.to = self.formular_mail.to.trim().toLowerCase();
                self.formular_mail.message = self.formular_mail.message.trim();
                self.formular_mail.xmloutput = '';
                // valideaza datele
                if (self.formular_mail.firstname.length === 0) {
                    $eventbus.$emit('open:alert', 'Merci de préciser votre prénom.');
                } else if (self.formular_mail.lastname.length === 0) {
                    $eventbus.$emit('open:alert', 'Merci de préciser votre nom.');
                } else if (self.formular_mail.from.length === 0) {
                    $eventbus.$emit('open:alert', 'Merci de préciser une adresse mail valide.');
                } else if (!self.isValidEmail(self.formular_mail.from)) {
                    $eventbus.$emit('open:alert', 'Merci de préciser une adresse mail valide.');
                } else if (self.formular_mail.to.length === 0) {
                    $eventbus.$emit('open:alert', 'Merci de préciser un e-mail de destinataire valide.');
                } else if (!self.isValidEmail(self.formular_mail.to)) {
                    $eventbus.$emit('open:alert', 'Merci de préciser un e-mail de destinataire valide.');
                } else {
                    // construieste xmloutput
                    self.formular_mail.xmloutput = '<?xml version="1.0" encoding="utf-8"?>';
                    self.formular_mail.xmloutput += '<sendtofriend>';
                    self.formular_mail.xmloutput += '<urlrequest><![CDATA[https://www.dimm.be/nos-catalogues/]]></urlrequest>';
                    self.formular_mail.xmloutput += '<finurl><![CDATA[https://www.dimm.be/nos-catalogues/]]></finurl>';
                    self.formular_mail.xmloutput += '<lang><![CDATA[' + self.formular_mail.lang + ']]></lang>';
                    self.formular_mail.xmloutput += '<page><![CDATA[1-2]]></page>';
                    self.formular_mail.xmloutput += '<firstname><![CDATA[' + self.formular_mail.firstname + ']]></firstname>';
                    self.formular_mail.xmloutput += '<lastname><![CDATA[' + self.formular_mail.lastname + ']]></lastname>';
                    self.formular_mail.xmloutput += '<from><![CDATA[' + self.formular_mail.from + ']]></from>';
                    self.formular_mail.xmloutput += '<to><![CDATA[' + self.formular_mail.to + ']]></to>';
                    self.formular_mail.xmloutput += '<message><![CDATA[' + self.formular_mail.message + ']]></message>';
                    self.formular_mail.xmloutput += '</sendtofriend>';
                    //
                    Email
                            .send({
                                xmloutput: self.formular_mail.xmloutput,
                                lang:  self.formular_mail.lang,
                                g_recaptcha_response:  self.formular_mail.g_recaptcha_response,
                                firstname:  self.formular_mail.firstname,
                                lastname:  self.formular_mail.lastname,
                                from:  self.formular_mail.from,
                                to:  self.formular_mail.to,
                                message:  self.formular_mail.message,
                            })
                            .then(function (result) {
                                var data = result.data;
                                if (data.indexOf('sendResult=false') !== -1) {
                                    $eventbus.$emit('open:alert', "Malheureusement votre e-mail n'a pas été envoyé.<br/>Veuillez essayer plus tard.");
                                } else {
                                    $eventbus.$emit('open:alert', "Votre e-mail a bien été envoyé.");
                                    self.clearEmail();
                                    self.toggleEmail();
                                }
                            })
                            .catch(function () {
                                $eventbus.$emit('open:alert', "Malheureusement votre e-mail n'a pas été envoyé.<br/>Veuillez essayer plus tard.");
                            })
                            .then(function () {
                                self.$refs.recaptcha.reset();
                            });
                }
            },
            //
            onCaptchaExpired: function () {
                const self = this;
                self.$refs.recaptcha.reset();
                self.clearEmail();
            },
            //
            clearEmail: function(){
                const self = this;
                self.formular_mail.g_recaptcha_response = '';
                self.formular_mail.lang = '';
                self.formular_mail.firstname = '';
                self.formular_mail.lastname ='';
                self.formular_mail.from = '';
                self.formular_mail.to = '';
                self.formular_mail.message = '';
                self.formular_mail.xmloutput = '';
            },
            //
            onCaptchaVerified: function (recaptchaToken) {
                const self = this;
                self.formular_mail.g_recaptcha_response = recaptchaToken;
            },
        }
    }
</script>

<style scoped>

</style>
